import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  CircularProgress,
  Typography,
  TextField,
  Button,
  Paper,
  Box,
  InputAdornment,
  Chip,
} from '@mui/material';
import {
  Search as SearchIcon,
  ContactMail as ContactMailIcon,
  PersonAdd as PersonAddIcon,
} from '@mui/icons-material';
import { obtenerContactos } from '../../../actions/ClientesAction';
import { useStateValue } from '../../../contexto/store';
import TContactos from './TContactos';
const ContactosPrincipal = (props) => {
  const mounted = useRef(true);
  const [term, setTerm] = useState('');
  const [{ sesionUsuario }] = useStateValue();
  const [DataC, setDataC] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);

  const abrirNuevo = () => {
    props.history.push('/contactosNuevo');
  };

  useEffect(() => {
    if (mounted.current) {
      const usuario = sesionUsuario.usuario.id;
      obtenerContactos(usuario).then((response) => {
        if (response.status === 200) {
          setDataC(response.data);
          setDatosCargados(true);
        } else {
          console.log('no cargo nada');
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [sesionUsuario]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <ContactMailIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Contactos
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <Chip
                label={`${DataC.length} contactos`}
                size="small"
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  fontWeight: 600,
                  backdropFilter: 'blur(10px)',
                }}
              />
            </Box>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<PersonAddIcon />}
          onClick={abrirNuevo}
          sx={{
            backgroundColor: 'white',
            color: '#0d47a1',
            fontWeight: 600,
            px: 3,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            boxShadow: 2,
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.9)',
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Nuevo Contacto
        </Button>
      </Paper>

      {/* Barra de búsqueda */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar contacto por nombre, apellido, CI, RUC o cliente..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'action.active' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Tabla de contactos */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          <TContactos rows={DataC} termc={term} history={props.history} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="h6" color="text.secondary">
              Cargando contactos...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};
export default ContactosPrincipal;
